import { Button, Modal, Icon } from 'semantic-ui-react';
import { useState } from 'react';
import Info from './Info';

function InfoModal({ type }) {
    const [modalOpen, setModalOpen] = useState(false);

    const handleClose = () => setModalOpen(false);
    const handleOpen = () => setModalOpen(true);

    const getModalConfig = (type) => {
        switch (type) {
            case 'imageGuidelines':
                return {
                    title: 'Profile Image Upload Guidelines:',
                    trigger: <Button
                        basic
                        color="red"
                        onClick={handleOpen}
                    ><Icon name='info circle' />
                        Profile Image Upload Guidelines
                    </Button>,
                    size: 'small'
                };
            case 'privacyPolicy':
                return {
                    title: 'Privacy Policy',
                    trigger: (
                        <span onClick={handleOpen} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
                            View Privacy Policy
                        </span>
                    ),
                    size: 'small'
                };
            case 'generalTermOfUse':
                return {
                    title: 'General Term of Use',
                    trigger: (
                        <span onClick={handleOpen} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
                            View General Term of Use
                        </span>
                    ),
                    size: 'small'
                };


            default:
                return {
                    title: 'Invalid modal trigger',
                    trigger: <div>Invalid modal trigger</div>,
                    size: 'small'
                };
        }
    };

    const { title, trigger, size } = getModalConfig(type);

    return (
        <Modal
            trigger={trigger}
            open={modalOpen}
            onClose={handleClose}
            size={size}
            closeOnDimmerClick={false}
        >
            <Modal.Header>{title}</Modal.Header>
            <Info handleInfoModalClose={handleClose} infoType={type} />
        </Modal>
    );
}

export default InfoModal;
